// @flow

const Data = [
  {
    imgName: 'apple-badge',
    alt: 'Apple App Store Badge',
    label: 'Download on the App Store',
    url: `https://itunes.apple.com/us/app/figure/id1387186310?ls=1&mt=8`,
  },
  {
    imgName: 'google-badge',
    alt: 'Google Play Badge',
    label: 'Get it on Google Play',
    url: `https://cdn.figure.com/apps/frontend-web/master-365/public/images/google-badge.svg`,
  },
];

export default Data;
